import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface AddOrUpdateProductTypeApiModel {
    id?: string;
    name: string;
    divisionId: string;
    ImageBase64?: string;
}

export interface ProductTypeModel {
    id: string;
    name: string;
    divisionName: string;
    divisionId: string;
    photoFile?: string;
}

export interface ProductTypeCollectionModel {
    productTypeModels: ProductTypeModel[];
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
    };
}

const baseUrl = "/api/v2/centroconnect/sme/admin/producttype";

export function addProductType(model: AddOrUpdateProductTypeApiModel) {
    return post<AddOrUpdateProductTypeApiModel, ProductTypeModel>(baseUrl, model as any);
}

export function getProductTypeCollection(page?: number, pageSize?: number,query?: string) {
     const params = new URLSearchParams();
    if (page !== undefined) {
        params.append('page', page.toString());
    }
    if (pageSize !== undefined) {
        params.append('pageSize', pageSize.toString());
    }
    if(query && query.trim()) {
        params.append('query', query.trim());
    }
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<ProductTypeCollectionModel>(url);
}

export function updateProductType(model: AddOrUpdateProductTypeApiModel) {
    return patch<any>(baseUrl, model as any) as Promise<ProductTypeModel>;
}

export const getProductTypeById = async (productTypeId: string): Promise<any> => {
    return get<ProductTypeModel>(`${baseUrl}/${productTypeId}`);
};

export function deleteProductType(productTypeId: string) {
    return del(`${baseUrl}/${productTypeId}`) as Promise<void>;
}
